import React, { FC } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContentText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { ConfirmDialogProps } from '../../models/ConfirmDialogProps';
import { isNullOrUndefined } from '../../utils/utils';
import useConfirmDialog from '../../hooks/dialogs/useConfirmDialog';

const ConfirmDialog: React.FC<{ dialogContent: ConfirmDialogProps }> = (
    props
) => {
    const confirmDialog = useConfirmDialog();
    if (isNullOrUndefined(props.dialogContent)) {
        return null;
    }

    const {
        onClose,
        title,
        content,
        confirmText,
        cancelText,
        onConfirm,
        onCancel,
    } = props.dialogContent;

    const closeConfirmDialog = () => {
        confirmDialog.closeDialog();
        if (!isNullOrUndefined(onClose)) {
            onClose();
        }
    };

    const cancelConfirmDialog = () => {
        confirmDialog.closeDialog();
        if (!isNullOrUndefined(onCancel)) {
            onCancel();
        }
    };

    const onConfirmDialog = () => {
        confirmDialog.closeDialog();
        onConfirm();
    };

    return (
        <Dialog
            open={true}
            onClose={closeConfirmDialog}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>
                {title}
                <CloseIcon
                    sx={{ cursor: 'pointer' }}
                    onClick={closeConfirmDialog}
                />
            </StyledDialogTitle>
            <StyledDialogContent>
                <DialogContentText>{content}</DialogContentText>
            </StyledDialogContent>
            <DialogActions>
                <Button size="small" onClick={cancelConfirmDialog}>
                    {cancelText}
                </Button>
                <Button
                    size="small"
                    onClick={onConfirmDialog}
                    sx={{ color: 'red' }}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
